import { invert } from 'lodash';
/* 
  Helper code to organize task types across the project
*/

// Any additions or changes here also need to be changed in the server side task types enum
const taskTypes = {
  general: 1,
  foodLog: 2,
  bodyStat: 3,
  progressPhoto: 4,
  cardio: 5,
  formCheck: 6,
  progressPhotoEntry: 7,
  bodyStatEntry: 8,
  foodLogEntry: 9,
  formCheckEntry: 10,
  nutrition: 11,
  lifestyle: 12,
  generalTrainerTask: 13,
  trainerTaskEndOfTrainingBlock: 14,
  message: 15,
  achievement: 16,
  personalRecord: 17,
  chatEUM: 18,
  chatLTM: 19,
  approvals: 20,
};

const stringForTaskType = invert(taskTypes);

const generalTaskTypes = [
  taskTypes.general,
  taskTypes.cardio,
  taskTypes.nutrition,
  taskTypes.lifestyle,
];

const actionTaskTypes = [
  taskTypes.foodLog,
  taskTypes.bodyStat,
  taskTypes.progressPhoto,
  taskTypes.formCheck,
  taskTypes.message,
];

const clientTaskTypes = [...generalTaskTypes, ...actionTaskTypes];

const trainerTaskTypes = [
  taskTypes.generalTrainerTask,
  taskTypes.trainerTaskEndOfTrainingBlock,
];

// Used by native client to route based on special task type
// Strings come from /lib/nav/AppNavigator.js
const mapTypeToRoute = new Map([
  [taskTypes.foodLog, { route: 'FoodLogScreen', label: 'Create Food Log' }],
  [taskTypes.bodyStat, { route: 'BodyStatScreen', label: 'Record Body Stat' }],
  [
    taskTypes.progressPhoto,
    { route: 'ProgressPhotosScreen', label: 'Take Progress Photo' },
  ],
  [
    taskTypes.formCheck,
    { route: 'MovementAssessmentScreen', label: 'Record Form Check' },
  ],
  [taskTypes.message, { route: 'ChatScreen', label: 'Send Message' }],
]);

const initialTaskTypeForSelectedEventType = {
  Task: taskTypes.general,
  ActionTask: taskTypes.foodLog,
  TrainerTask: taskTypes.generalTrainerTask,
};

const taskEventTypeForTaskType = (taskTypeId) => {
  let eventType = 'Task';
  if (actionTaskTypes.includes(taskTypeId)) {
    eventType = 'ActionTask';
  }
  if (trainerTaskTypes.includes(taskTypeId)) {
    eventType = 'TrainerTask';
  }
  return eventType;
};

const itemTypesForTaskProgramsEnum = {
  task: 0,
  workout: 1,
};

export {
  taskTypes,
  generalTaskTypes,
  actionTaskTypes,
  trainerTaskTypes,
  clientTaskTypes,
  mapTypeToRoute,
  stringForTaskType,
  initialTaskTypeForSelectedEventType,
  taskEventTypeForTaskType,
  itemTypesForTaskProgramsEnum,
};
